import { useOutlet } from "react-router-dom";

export const ProtectedLayout = () => {
  const outlet = useOutlet();

  return <>{outlet}</>;
};
